var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47327 0.328033C8.68202 0.210609 8.9175 0.148926 9.15701 0.148926C9.39653 0.148926 9.632 0.210609 9.84076 0.328033L17.5113 4.64273C17.727 4.76405 17.9065 4.94058 18.0315 5.15419C18.1564 5.3678 18.2222 5.6108 18.2222 5.85827V14.4565C18.2222 14.704 18.1564 14.947 18.0315 15.1606C17.9065 15.3742 17.727 15.5507 17.5113 15.672L9.84076 19.9867C9.632 20.1042 9.39653 20.1658 9.15701 20.1658C8.9175 20.1658 8.68202 20.1042 8.47327 19.9867L0.802703 15.672C0.587021 15.5507 0.407502 15.3742 0.282571 15.1606C0.15764 14.947 0.0917967 14.704 0.0917969 14.4565V5.85827C0.091797 5.61081 0.157642 5.3678 0.282572 5.15419C0.407502 4.94058 0.58702 4.76405 0.802703 4.64273L8.47327 0.328033ZM9.15701 1.54357L1.48645 5.85827L1.48645 14.4565L9.15701 18.7712L16.8276 14.4565V5.85827L9.15701 1.54357Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.276729 5.16477C0.46413 4.82832 0.888797 4.70749 1.22525 4.89489L9.23658 9.35717L17.0845 4.89857C17.4194 4.70833 17.8451 4.82556 18.0353 5.16042C18.2255 5.49527 18.1083 5.92095 17.7734 6.11118L9.58442 10.7636C9.37264 10.8839 9.11343 10.885 8.90064 10.7664L0.546607 6.11329C0.210156 5.92589 0.0893272 5.50122 0.276729 5.16477Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24622 9.45999C9.63133 9.46337 9.94077 9.77831 9.93739 10.1634L9.85556 19.4746C9.85218 19.8597 9.53724 20.1691 9.15213 20.1657C8.76703 20.1623 8.45758 19.8474 8.46096 19.4623L8.54279 10.1512C8.54618 9.76605 8.86111 9.4566 9.24622 9.45999Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTable);
export default __webpack_public_path__ + "static/media/add_table.aab8df16.svg";
export { ForwardRef as ReactComponent };